<template>
  <div class="systembody">
    <HelpComp />
  </div>
</template>

<script>
import HelpComp from '@/components/help/HelpComp.vue'
import Auth from '@/services/auth.service.js'

export default {
  name: 'HelpView',
  components: {
    HelpComp,
  },
  created() {
    document.title = 'מידע ועזרה | clickcall'
    let auth = Auth.checkAuth();
    if (!auth) {
      this.$router.replace({ name: "login" })
    }
  },
}
</script>